export const phoneValueCasting = (value: string) =>
  `+7${value?.replace(/[\(\)\- ]/g, '') || ''}`;
